const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

/**
 * Push app settings to all Azure App Services in bulk.
 * @param {Array<{appServiceName: string, resourceGroupName: string, settings: Array<{name: string, value: string, slotSetting: boolean}>}>} batches
 * @returns {Promise<Array<{appServiceName: string, success: boolean, message: string, details?: string}>>}
 */
export const pushAllAppSettings = async (batches) => {
  const url = `${API_BASE_URL}/api/appsettings/push-all`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ batches }),
  });

  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data?.[0]?.message || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }
  return data;
};
